import { Button, TextLink } from "@origin-digital/ods-core";
import styled from "styled-components";

export const SummaryWrapper = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledTextLink = styled(TextLink)`
  text-decoration: none !important;
  color: inherit !important;
  &:hover {
    text-decoration: underline !important;
  }
`;

export const ScrollableSourcesContainer = styled.div<{ $isExpanded: boolean }>`
  overflow-y: ${({ $isExpanded }) => ($isExpanded ? "auto" : "visible")};
  overflow-x: hidden;

  ${({ theme }) => theme.breakpoints.up("md")} {
    ${({ $isExpanded }) =>
      $isExpanded &&
      `
      flex: 1;
      min-height: 0;
    `}
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    overflow-y: visible;
  }
`;

export const FixedHeightWrapper = styled.div<{ $isExpanded: boolean }>`
  ${({ theme }) => theme.breakpoints.up("md")} {
    ${({ $isExpanded }) =>
      $isExpanded &&
      `
      max-height: 560px;
      display: flex;
      flex-direction: column;
    `}
  }
`;

export const TransparentButton = styled(Button)`
  && {
    border: 1px solid ${({ theme }) => theme.colors.neutralLight};
  }
`;
